export default {
  CATEGORIES_GET_REQUEST: 'categories/getCategoriesRequest',
  CATEGORIES_GET_SUCCESS: 'categories/getCategoriesSuccess',
  CATEGORIES_GET_ERROR: 'categories/getCategoriesError',
};
